<template>
  <div :class="['coupon', { 'coupon-expired': expired }]" :data-coupon-id="coupon.coupon_id">
    <div class="coupon-body" @click="showCoupon(coupon)">
      <div v-if="!showLogo" class="coupon-label">
        <div :class="['coupon-announcement', { 'coupon-announcement-action': coupon.type == 'action' }]" v-if="!expired">
          <span class="coupon-type">{{ $t(types[coupon.type]) }}</span>
          <span class="coupon-discount" v-if="coupon.discount_value">{{ coupon.discount_value }}</span>
          <span class="coupon-present" v-else>%</span>
        </div>
        <img class="coupon-img" src="../../../img/coupon-img-expired.svg" width="84" height="55" alt="" v-if="!coupon.discount_value && expired">
      </div>
      <div v-if="showLogo" class="coupon-label">
        <app-img :src="coupon.image || coupon.logo_url" :alt="coupon.slug"></app-img>
        <a class="coupon-shop-link" :href="shopUrl(coupon.slug)" @click="(e) => e.stopPropagation()">{{ $t('Промокоды') }} {{ coupon.shop_name }}</a>
      </div>
      <div class="coupon-description">
        <span class="vwo-coupon-works" v-if="!!coupon.gotolink">{{ $t('Проверено, работает') }}!</span>
        <a class="coupon-title" :href="`${shopUrl(coupon.slug)}?coupon=${coupon.coupon_id}`" @click="(e) => e.preventDefault()" v-html="coupon.name" rel="nofollow"></a>
        <p class="coupon-short-description" v-if="coupon.description && coupon.description.toLowerCase()!='промокод не требуется'">{{ coupon.description && coupon.description.length > 120 ? `${coupon.description.slice(0, 120)}...` : coupon.description }}</p>
        <div class="coupon-usage hidden-md hidden-sm" style="text-align: left;">
          <img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDk3LjE2IDk3LjE2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA5Ny4xNiA5Ny4xNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00OC41OCwwQzIxLjc5MywwLDAsMjEuNzkzLDAsNDguNThzMjEuNzkzLDQ4LjU4LDQ4LjU4LDQ4LjU4czQ4LjU4LTIxLjc5Myw0OC41OC00OC41OFM3NS4zNjcsMCw0OC41OCwweiBNNDguNTgsODYuODIzICAgIGMtMjEuMDg3LDAtMzguMjQ0LTE3LjE1NS0zOC4yNDQtMzguMjQzUzI3LjQ5MywxMC4zMzcsNDguNTgsMTAuMzM3Uzg2LjgyNCwyNy40OTIsODYuODI0LDQ4LjU4UzY5LjY2Nyw4Ni44MjMsNDguNTgsODYuODIzeiIgZmlsbD0iI2JlYmViZSIvPgoJCTxwYXRoIGQ9Ik03My44OTgsNDcuMDhINTIuMDY2VjIwLjgzYzAtMi4yMDktMS43OTEtNC00LTRjLTIuMjA5LDAtNCwxLjc5MS00LDR2MzAuMjVjMCwyLjIwOSwxLjc5MSw0LDQsNGgyNS44MzIgICAgYzIuMjA5LDAsNC0xLjc5MSw0LTRTNzYuMTA3LDQ3LjA4LDczLjg5OCw0Ny4wOHoiIGZpbGw9IiNiZWJlYmUiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" style="margin-bottom: -3px; display: inline;">
          {{ couponEnd }}
          <img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2My40MyA1NjMuNDMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2My40MyA1NjMuNDM7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTI4MC43OSwzMTQuNTU5YzgzLjI2NiwwLDE1MC44MDMtNjcuNTM4LDE1MC44MDMtMTUwLjgwM1MzNjQuMDU1LDEzLjQxNSwyODAuNzksMTMuNDE1UzEyOS45ODcsODAuOTUzLDEyOS45ODcsMTYzLjc1NiAgUzE5Ny41MjQsMzE0LjU1OSwyODAuNzksMzE0LjU1OXogTTI4MC43OSw1Mi43MzVjNjEuMDYxLDAsMTExLjAyMSw0OS45NTksMTExLjAyMSwxMTEuMDIxUzM0MS44NTEsMjc0Ljc3NiwyODAuNzksMjc0Ljc3NiAgcy0xMTEuMDIxLTQ5Ljk1OS0xMTEuMDIxLTExMS4wMjFTMjE5LjcyOCw1Mi43MzUsMjgwLjc5LDUyLjczNXoiIGZpbGw9IiNiZWJlYmUiLz4KPHBhdGggZD0iTTE5Ljg5MSw1NTAuMDE1aDUyMy42NDhjMTEuMTAyLDAsMTkuODkxLTguNzg5LDE5Ljg5MS0xOS44OTFjMC0xMDQuMDgyLTg0LjY1My0xODkuMTk4LTE4OS4xOTgtMTg5LjE5OEgxODkuMTk4ICBDODUuMTE2LDM0MC45MjYsMCw0MjUuNTc5LDAsNTMwLjEyNEMwLDU0MS4yMjYsOC43ODksNTUwLjAxNSwxOS44OTEsNTUwLjAxNXogTTE4OS4xOTgsMzgwLjcwOGgxODUuMDM0ICBjNzUuODY0LDAsMTM4LjMxMyw1Ni40MzYsMTQ4LjAyOCwxMjkuNTI0SDQxLjE3QzUwLjg4NCw0MzcuNjA3LDExMy4zMzQsMzgwLjcwOCwxODkuMTk4LDM4MC43MDh6IiBmaWxsPSIjYmViZWJlIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=" style="margin-left: 10px; margin-bottom: -3px; display: inline;">
          {{ Math.max(coupon.coupon_clicks, 10, coupon.coupon_id % 100) }}
        </div>
        <noindex>
          <div class="coupon-usage-wrapper hidden-lg">
            <span class="coupon-usage">{{ $t('Воспользовались') }}: {{ Math.max(coupon.coupon_clicks, 10, coupon.coupon_id % 100) }} {{ $tc('человек', Math.max(coupon.coupon_clicks, 10, coupon.coupon_id % 100)) }}</span>
            <span class="coupon-usage-divider hidden-lg hidden-sm"> / </span>
            <span :class="['coupon-usage', { 'expire': lessThanOneDay }]">{{ couponEnd }}</span>
          </div>
        </noindex>
      </div>
      <div class="coupon-actions">
        <noindex><div class="coupon-usage hidden-lg hidden-md hidden-sm">{{ $t('Воспользовались') }}: {{ Math.max(coupon.coupon_clicks, 10, coupon.coupon_id % 100) }} {{ $tc('человек', Math.max(coupon.coupon_clicks, 10, coupon.coupon_id % 100)) }}</div></noindex>
        <shop-coupon-button :type="coupon.type" :promocode="coupon.promocode"></shop-coupon-button>
        <!-- <button class="button-primary coupon-button">
          <span class="coupon-button-text">{{ coupon.type === 'promo' ? $t('Показать промокод') : $t('Получить скидку') }}</span>
          <span class="coupon-button-icon">
            <icon-base width="30" height="30"><icon-chevron-right/></icon-base>
          </span>
        </button> -->
        <span :class="['coupon-usage', 'hidden-lg', 'hidden-md', 'hidden-sm', { 'expire': lessThanOneDay }]">{{ couponEnd }}</span>
      </div>
    </div>
    <div class="coupon-footer hidden-lg hidden-md hidden-sm">
      <div class="coupon-more-info">
        <span class="coupon-show-details" @click="toggleDetails" v-if="coupon.description">
          {{ $t('Подробнее о купоне') }}
          <icon-base width="18" height="18" v-if="!showDetails"><icon-chevron-down/></icon-base>
          <icon-base width="18" height="18" v-if="showDetails"><icon-chevron-up/></icon-base>
        </span>
        <span class="coupon-vote-taken" v-if="voted">{{ $t('Ваш голос учтен, спасибо') }}</span>
        <div class="coupon-vote-icons" v-if="!voted">
          <button @click="vote" data-answer="vote_yes">
            <icon-base width="20" height="20"><icon-thumb-up-x/></icon-base>
          </button>
          <button @click="vote" data-answer="vote_no">
            <icon-base width="20" height="20"><icon-thumb-down-x/></icon-base>
          </button>
        </div>
      </div>
      <div class="coupon-showed-details" v-show="showDetails">
        <!--noindex-->
        <p class="coupon-details-description">{{ coupon.description }}</p>
        <!--/noindex-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import format from 'date-fns/format';
import utils from '../../mixins/utils.js';
import IconBase from '../IconBase.vue';
import IconChevronDown from '../icons/IconChevronDown.vue';
import IconChevronUp from '../icons/IconChevronUp.vue';
import IconThumbDownX from '../icons/IconThumbDownX.vue';
import IconThumbUpX from '../icons/IconThumbUpX.vue';
import AppImg from '../AppImg.vue';
import ShopCouponButton from './ShopCouponButton.vue';

export default {
  name: 'shop-coupon',

  mixins: [utils],

  components: {
    IconBase,
    IconChevronDown,
    IconChevronUp,
    IconThumbDownX,
    IconThumbUpX,
    AppImg,
    ShopCouponButton,
  },

  props: {
    showLogo: false,
    coupon: Object
  },

  data() {
    return {
      types: {
        'promo': 'промокод',
        'action': 'акция'
      },
      voted: false,
      showDetails: false,
    };
  },

  computed: {
    couponEnd() {
      const diff = this.getDiff();
      let seconds = Math.floor(diff / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
      hours %= 24;
      minutes %= 60;
      seconds %= 60;

      const dateEndMs = new Date(this.coupon.date_end.replace(/-/g, '/')).valueOf();
      const monthMs = 1000 * 60 * 60 * 24 * 30;
      const nowPlusMonthMs = new Date().valueOf() + monthMs;

      if (nowPlusMonthMs < dateEndMs) {
        return this.$t('Действует');
      } else {
        if (days >= 1) {
          return `${days} ${this.$t('д.')}`;
        } else {
          return `${hours} ${this.$t('ч.')}`;
        }
      }
    },

    lessThanOneDay() {
      const diff = this.getDiff();
      return diff > 0 && diff < 1000 * 60 * 60 * 24;
    },

    expired() {
      const diff = this.getDiff();
      return diff < 0;
    }
  },

  methods: {
    getDiff() {
      const from = new Date().valueOf();
      const to = new Date(this.coupon.date_end.replace(/-/g, '/')).valueOf();
      const diff = to - from;
      return diff;
    },

    async vote(e) {
      const { answer } = e.currentTarget.dataset;
      await axios.post(this.eventUrl(), { store: this.coupon.slug, coupon_id: this.coupon.coupon_id, event: answer });
      this.voted = true;
    },

    toggleDetails(e) {
      e.preventDefault();
      this.showDetails = !this.showDetails;
    }
  }
};
</script>

<style>
.vwo-coupon-works {
  display: none;
  border-radius: 3px;
  padding: 2px 3px;
  font-size: 13px;
  color: #fff;
  background: #386e2c;
}

@media (max-width: 767px) {
  .vwo-coupon-works {
    margin: 0 0 5px 0;
  }
}

.coupon {
  margin: 0 0 10px 0;
  background-color: #ffffff;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  cursor: pointer;
}

.coupon-body {
  display: flex;
  min-height: 155px;
  padding: 25px 20px;
}

.coupon-label {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px 0 0;
  width: 100%;
  max-width: 110px;
  text-align: center;
  color: #ff1d48;
}

.coupon-announcement-action {
  color: #ff7f32;
}

.coupon-announcement {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3px;
  width: 100%;
  min-height: 110px;
}

.coupon-type {
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
}

.coupon-discount {
  font-weight: bold;
  font-size: 35px;
}

.coupon-present {
  font-weight: 700;
  font-size: 42px;
}

.coupon-shop-link {
  margin: 5px 0 0 0;
  color: #3c91e6;
  font-size: 12px;
}

.coupon-shop-link:hover {
  color: #29629c;
  text-decoration: underline;
}

.coupon-shop-link:active {
  color: #2c316b;
}

.coupon-description {
  padding: 0 10px 0 0;
}

.coupon-short-description {
  display: block;
  line-height: 1.5;
  color: #878f96;
  font-size: 13px;
}

.coupon-title {
  display: block;
  margin: 10px 0;
  font-size: 21px;
  line-height: 30px;
}

.coupon-actions {
  display: flex;
  flex-direction: column;
  margin-left: auto;
}

.coupon-usage-wrapper {
  display: flex;
  font-size: 13px;
  color: #666872;
}

.coupon-usage-divider {
  margin: 0 5px;
}

.coupon-usage {
  font-size: 12px;
  text-align: center;
  color: #bebebe;
}

.coupon-usage.expire {
  color: #3c91e6;
}

.coupon-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  background-color: #fafafb;
  border-top: 1px solid #dbdce1;
}

.coupon-more-info {
  display: flex;
  align-items: center;
  height: 45px;
  color: #868993;
}

.coupon-show-details {
  display: flex;
  align-items: center;
  padding-right: 10px;
  font-size: 13px;
  cursor: pointer;
}

.coupon-show-details:hover svg {
  color: #3c91e6;
}

.coupon-show-details:active svg {
  color: #29629c;
}

.coupon-vote-icons,
.coupon-vote-taken {
  margin: 0 0 0 auto;
}

.coupon-vote-icons button {
  border: none;
  padding: 0;
  background-color: transparent;
  color: #dbdce1;
  cursor: pointer;
}

.coupon-vote-icons button:hover {
  color: #3c91e6;
}

.coupon-vote-icons button:active {
  color: #29629c;
}

.coupon-vote-taken {
  font-size: 13px;
}

.coupon-showed-details {
  height: 130px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  overflow: auto;
}

.coupon-details-description {
  margin: 0;
  margin-bottom: 25px;
  line-height: 22px;
}

.coupon-details-description:last-child {
  margin-bottom: 0;
}

.coupon-details-description span {
  font-weight: bold;
}

.coupon-expired .coupon-label {
  color: #868993;
}

@media (max-width:1023px) {
  .coupon-short-description {
    display: none;
  }

  .coupon-usage {
    text-align: left;
  }
}

@media (max-width: 767px) {
  .coupon {
    margin: 0 0 5px 0;
  }

  .coupon-body {
    padding: 15px 12px;
    min-height: auto;
  }

  .coupon-label {
    max-width: 90px;
    margin: 0 12px 0 0;
  }

  .coupon-announcement {
    min-height: 90px;
  }

  .coupon-discount {
    font-size: 22px;
  }

  .coupon-present {
    font-size: 35px;
  }

  .coupon-title {
    margin: 0 0 5px 0;
    padding: 0;
    font-size: 16px;
    line-height: 18px;
  }

  .coupon-usage-wrapper {
    display: flex;
    flex-direction: column;
  }

  .coupon-usage-wrapper > .coupon-usage:not(:last-child) {
    margin: 0 0 5px 0;
  }

  .coupon-usage {
    font-size: 12px;
  }
}
</style>